import Vue from "vue";
import Variable from "../Variable.vue";
export default Vue.extend({
    components: {
        Variable,
    },
});
